export default "__VITE_ASSET__Dj7kvKl9__"